import React from 'react';
import { NextSeo, BreadcrumbJsonLd, FAQPageJsonLd } from 'next-seo';
import { seoConfig, appConfig } from 'configs';
import styled from 'styled-components';
import { useRouter } from 'next/router';

// libs and consts
import Translation from 'libs/Translation';

// components
import Text from 'components/common/Text';

// style
const Wrapper = styled.main`
	box-sizing: border-box;
    min-width: 0;
    display: flex;
    flex: 1;
	flex-direction: column;
	background-color: transparent;	
	padding: ${p => p.padding};

	.hidden {
		display: none;
	}
`;

// Main Component
const Main = ({ children, seo, breadCrumb, faq, addTitlePost, ...restProps }) => {
	const router = useRouter();
	const {lang} = router.query;

	let { additionalMetaTags, h1Title, canonical } = seo;
	canonical = canonical ?? `${appConfig.site_url}${router.asPath}`;

	if (seo.keywords) {
		additionalMetaTags.push({ name: 'keywords', content: seo.keywords });
	}

	const finalSeo = {
		...seoConfig,
		...seo,
		additionalMetaTags: additionalMetaTags?.length > 0 ? [...seoConfig.additionalMetaTags, ...additionalMetaTags] : seoConfig?.additionalMetaTags,
		openGraph: {
			locale: lang === 'en' ? 'en_US' : 'fa_IR',
			...seoConfig?.openGraph, ...seo?.openGraph ,
		},
		canonical
	};

	if (seo.title) {
		finalSeo.title = seo.title;

		if (addTitlePost) {
			finalSeo.title += ` | ${Translation.t('title.default')}`;
		}
	}

	return (
		<Wrapper {...restProps}>
			{seo ? <NextSeo {...finalSeo} /> : null}
			{breadCrumb ? <BreadcrumbJsonLd {...breadCrumb} /> : null}
			{faq ? <FAQPageJsonLd {...faq} /> : null}
			{h1Title ? <Text className="hidden" size="lll" tag="h1">{h1Title}</Text> : null}
			{children}
		</Wrapper>
	);
};

/* Export ================================== */
export default Main;
